import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import CommonHeader from '@components/ssap/headers/CommonHeader';

// ActionCreators

import { showModal } from '@actions/common/actionCreators';

// Constants

import { lceModalTypes } from '@constants/lce/modals/lceModalTypes';


const LceContainer = props => {

    const {
        actions,
        environment: {
            exchangeName
        }
    } = props;

    const lifeChangeEvents = [
        [
            {
                text: 'Loss of Minimum Essential Coverage',
                type: lceModalTypes.LOSS_COVERAGE_MODAL
            },
            {
                text: 'Marriage',
                type: lceModalTypes.MARRIAGE_MODAL
            },
            {
                text: 'Divorce & Legal Separation',
                type: lceModalTypes.DIVORCE_AND_SEPARATION_MODAL
            },
            {
                text: 'Change in Your Dependents',
                type: lceModalTypes.CHANGE_IN_DEPENDANTS_MODAL
            },
            {
                text: 'Death',
                type: lceModalTypes.DEATH_MODAL
            },
            {
                text: 'Change of Address',
                type: lceModalTypes.CHANGE_OF_ADDRESS_MODAL
            }
        ],
        [
            {
                text: 'Change in Income',
                type: lceModalTypes.CHANGE_IN_INCOME_MODAL
            },
            {
                text: 'Change in Immigration Status',
                type: lceModalTypes.CHANGE_IN_IMMIGRATION_STATUS_MODAL
            },
            {
                text: 'Change in Incarceration Status',
                type: lceModalTypes.CHANGE_IN_INCARCERATION_STATUS_MODAL
            },
            {
                text: 'Denied Medicaid/CHIP',
                type: lceModalTypes.DENIED_MEDICAID_CHIP_MODAL
            },
            {
                text: 'Native Americans',
                type: lceModalTypes.NATIVE_AMERICANS_MODAL
            }
        ]
    ];

    const [ items, toggleItemSelection ] = useState(
        [
            ...lifeChangeEvents
                .reduce((wholeArray, subarray) => [...wholeArray, ...subarray], [])
                .map(item => ({ ...item, isSelected: false }))
        ]
    );

    const [ records, updateRecords ] = useState([]);

    const changeItemStatus = lce => {
        toggleItemSelection(
            items => items
                .map(item => item.type === lce ?
                    { ...item, isSelected: !item.isSelected }
                    : item
                )
        );
    };

    const handleItemClick = e => {
        const {
            currentTarget: {
                dataset: {
                    lce
                }
            }
        } = e;

        if(lce === lceModalTypes.MARRIAGE_MODAL) {
            actions.showModal({
                modalType: lceModalTypes.MARRIAGE_MODAL,
                modalData: {
                    records,
                    lce,
                    callbacks: [
                        records => updateRecords(records),
                        () => changeItemStatus(lce)
                    ]
                }
            });
        } else {
            alert('Modal for this item is not ready now!');
        }

        changeItemStatus(lce);
    };




    const getEventItems = () => {

        return lifeChangeEvents.map((col , idx)=> {
            return (
                <div
                    key={`${col[0]}_${idx}`}
                    style={{
                        float: 'left',
                        width: '45%',
                        margin: '10px'
                    }}
                >
                    {
                        col.map(item => {

                            const it = items.find(i => i.type === item.type);

                            return (
                                <div
                                    className={`lce-item-${it.isSelected ? 'active' : 'passive'}`}
                                    data-lce={it.type}
                                    key={it.type}
                                    style={{
                                        border: '1px solid black',
                                        padding: '5px' ,
                                        borderRadius: '5px',
                                        marginBottom: '10px',
                                        backgroundColor: it.isSelected ? 'red' : 'initial',
                                        cursor: 'pointer'
                                    }}
                                    onClick={handleItemClick}
                                >
                                    <img
                                        src="../../../assets/small37-256.png"
                                        alt="Smiley face"
                                        height='20' width='20'
                                        style={{ margin: '0 10px' }}
                                    />
                                    <span
                                        style={{
                                            marginLeft: '20px' ,
                                            lineHeight: '45px'
                                        }}
                                    >
                                        <strong>
                                            { item.text }
                                        </strong>
                                    </span>
                                    <hr/>
                                </div>
                            );
                        })
                    }
                </div>
            );
        });
    };

    return (
        <div
            style={{
                padding: '0 10%',
                overflow: 'hidden'
            }}
        >
            <CommonHeader headerText='Add Qualifying Events'/>
            <div className="usa-alert usa-alert--info gi-alert gi-alert__info">
                <div className="usa-alert-body gi-alert__info__body">
                    <p className="usa-alert-text gi-alert__info__text">
                        <FormattedMessage id='lce.after_open_enrollment' values={{ eName: <strong>{exchangeName}</strong> }}/>
                        <br/>
                        <FormattedMessage id='lce.click_to_qualify'/>
                    </p>
                </div>
            </div>
            {
                records.map(r => {

                    const handleItemDeletion = rec => {
                        updateRecords(records => records.filter(r => r !== rec));
                    };

                    const handleItemEdition = modal_type => {
                        actions.showModal(
                            modal_type,
                            modal_type,
                            [
                                records,
                                r
                            ],
                            [
                                records => updateRecords(records),
                                () => changeItemStatus(r)
                            ]
                        );
                    };

                    return (
                        <div
                            key={r}
                            style={{ border: '1px solid teal' }}
                        >
                            <h3 key={r}> { r } </h3>
                            <button onClick={() => handleItemDeletion(r)}> x </button>
                            <button onClick={() => handleItemEdition(r)}> Edit </button>
                        </div>
                    );
                })
            }
            <div
                style={{
                    width: '80%',
                    margin: '0 auto'
                }}
            >
                { getEventItems() }
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        showModal
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LceContainer);
